"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Caption = void 0;

var _palette = require("@artsy/palette");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ArtworkCaption = require("./ArtworkCaption");

var _Responsive = require("../../../../Utils/Responsive");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Caption = function Caption(_ref, context) {
  var index = _ref.index,
      open = _ref.open,
      section = _ref.section,
      total = _ref.total;
  var isArtwork = section.type === "artwork";
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Responsive.Media, {
    lessThan: "sm"
  }, _react.default.createElement(_palette.Box, {
    p: 2,
    bg: "black5"
  }, _react.default.createElement(_palette.Clickable, {
    display: "flex",
    width: "100%",
    onClick: context.onToggleCaption
  }, _react.default.createElement(_palette.Text, {
    flex: "1",
    variant: "caption",
    textAlign: "left",
    style: {
      textDecoration: "underline"
    }
  }, open ? "Hide" : "View Caption"), _react.default.createElement(_palette.Text, {
    variant: "caption"
  }, index, " of ", total)), open && _react.default.createElement(_palette.Box, {
    pt: 2
  }, isArtwork ? _react.default.createElement(_ArtworkCaption.ArtworkCaption, {
    display: "flex",
    flex: "1",
    section: section
  }) : _react.default.createElement(_palette.HTML, {
    variant: "caption",
    html: section.caption
  })))), _react.default.createElement(_Responsive.Media, {
    greaterThanOrEqual: "sm"
  }, _react.default.createElement(_palette.Box, {
    position: "relative",
    zIndex: 2,
    display: "flex",
    px: 6,
    py: 3,
    bg: "black5"
  }, _react.default.createElement(_palette.Box, {
    flex: "1"
  }, isArtwork ? _react.default.createElement(_ArtworkCaption.ArtworkCaption, {
    display: "flex",
    flex: "1",
    section: section
  }) : _react.default.createElement(_palette.HTML, {
    variant: "caption",
    html: section.caption
  })), _react.default.createElement(_palette.Text, {
    variant: "caption",
    pl: 2
  }, index, " of ", total))));
};

exports.Caption = Caption;
Caption.contextTypes = {
  onToggleCaption: _propTypes.default.func
};
//# sourceMappingURL=Caption.js.map